import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
import { z } from "zod";
import { ensureElementVisible } from "@/lib/route-guards";

const CoverageGapsPage = lazy(() => import("@/features/reports/coverage-gaps-page"));

// `.catch(undefined)` — zły param w URL (stary bookmark) traktuj jak brak,
// strona ładuje się z domyślnymi wartościami zamiast crashować trasę.
const isoDate = z
	.string()
	.regex(/^\d{4}-\d{2}-\d{2}$/)
	.optional()
	.catch(undefined);

const searchSchema = z.object({
	scope: z.string().optional(),
	dateFrom: isoDate,
	dateTo: isoDate,
	horyzont: z.coerce.number().int().min(1).max(60).optional().catch(undefined),
});

export type CoverageGapsSearch = z.infer<typeof searchSchema>;

export const Route = createFileRoute("/_auth/raporty/luki-powiazan")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.raporty.luki-powiazan",
			location.pathname,
		);
	},
	component: CoverageGapsPage,
	validateSearch: (search: Record<string, unknown>): CoverageGapsSearch =>
		searchSchema.parse(search),
});
